import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const SwitchOff = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={20}
      viewBoxHeight={20}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="5"
        width="20"
        height="10"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path fill="#D9D9D9" d="M0 0h20v20H0z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M5.833 15c-1.388 0-2.569-.486-3.541-1.458C1.32 12.569.833 11.389.833 10c0-1.389.487-2.57 1.459-3.542C3.264 5.486 4.445 5 5.834 5h8.333c1.389 0 2.57.486 3.542 1.458.972.973 1.458 2.153 1.458 3.542 0 1.389-.486 2.57-1.459 3.542-.972.972-2.152 1.458-3.541 1.458H5.833Zm0-1.667h8.334a3.21 3.21 0 0 0 2.354-.979 3.21 3.21 0 0 0 .98-2.354 3.21 3.21 0 0 0-.98-2.354 3.21 3.21 0 0 0-2.354-.98H5.833a3.21 3.21 0 0 0-2.354.98A3.21 3.21 0 0 0 2.5 10c0 .917.327 1.701.98 2.354a3.21 3.21 0 0 0 2.353.98Zm0-.833c.695 0 1.285-.243 1.771-.73a2.41 2.41 0 0 0 .73-1.77 2.41 2.41 0 0 0-.73-1.77 2.41 2.41 0 0 0-1.77-.73 2.41 2.41 0 0 0-1.771.73 2.41 2.41 0 0 0-.73 1.77c0 .694.244 1.285.73 1.77.486.487 1.076.73 1.77.73Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M0 0h20v20H0z" />
      </g>
    </Icon>
  );
};

SwitchOff.displayName = 'SwitchOff';

export default SwitchOff;
